// Public Family offer verified on themagicletterbox.com on 2026-09-26.
// Keep offer copy shared across the website and requested PDF-delivery email.
export const FAMILY_OFFER = {
  price: "$15/year",
  trialLetters: 5,
  children: 6,
} as const;

export type MagicLetterDestination = "signup" | "elf" | "santa" | "birthday";

const destinations: Record<MagicLetterDestination, string> = {
  signup: "/signup",
  elf: "/letters/holiday-elf",
  santa: "/letters/santa",
  birthday: "/letters/birthday",
};

export function magicLetterBoxUrl(
  source: string,
  { campaign = "christmas-letters", medium = "referral", destination = "signup" }: {
    campaign?: string;
    medium?: string;
    destination?: MagicLetterDestination;
  } = {},
): string {
  const url = new URL(destinations[destination], "https://themagicletterbox.com");
  if (destination === "signup") {
    url.searchParams.set("occasion", "elf-on-shelf");
    url.searchParams.set("plan", "family");
  }
  url.searchParams.set("utm_source", "elfletterbot");
  url.searchParams.set("utm_medium", medium);
  url.searchParams.set("utm_campaign", campaign);
  url.searchParams.set("utm_content", source);
  return url.toString();
}
